<template>
  <Modal :model-value="modelValue" content-class="max-w-lg" @update:model-value="$emit('update:modelValue', false)">
    <div class="p-6">
      <div class="mb-4 flex items-center justify-between gap-10">
        <h5 class="text-xl text-primary-dark dark:text-primary-light">
          What project are you looking for?
        </h5>
        <Btn size="icon" color="gray" @click="$emit('update:modelValue', false)">
          <XIcon class="size-6" />
        </Btn>
      </div>

      <ContactForm v-slot="{ loading }">
        <div class="mt-8 flex justify-between">
          <Btn type="submit" :loading="loading">
            Send Request
          </Btn>
        </div>
      </ContactForm>
    </div>
  </Modal>
</template>

<script setup lang="ts">
import XIcon from '~/components/Icons/XIcon.vue'
import ContactForm from '~/components/Shared/ContactForm.vue'
import Btn from '~/components/UI/Btn.vue'
import Modal from '~/components/UI/Modal.vue'

interface Props {
  modelValue: boolean
}

defineProps<Props>()

defineEmits<{
  'update:modelValue': [value: boolean]
}>()
</script>
